<template>
    <v-app class="myBlue">
        <Header />
        <ShowList />
    </v-app>
</template>

<script>
import Header from "../components/kitchen/Header.vue";
import ShowList from "../components/kitchen/ShowList.vue";

export default {
    components: {
        Header,
        ShowList,
    },
};
</script>
